export default "__VITE_ASSET__jfenAW31__"